var table_viewer_default = {
  "viewMode": "vO1Vc",
  "editMode": "jJmZx",
  "container": "BHbx8",
  "cell": "ti29q"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
